import { globalStorage } from "../helpers";

export default function useGlobalParams() {
  const yearData = globalStorage.getItem("fin_year_data")
  return {
    organization_id: globalStorage.getItem("fin_user_data")?.organization_code,
    username: globalStorage.getItem("fin_user_data")?.username,
    signature: globalStorage.getItem("fin_user_data")?.signature,
    db_year: yearData?.start_date ? yearData?.year : (yearData || ""),
  };
}
